export default __webpack_public_path__ + "static/media/1-small.58bbb9cc.png";